import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class Bulk extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, Bulk._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static DEFAULT = new AString('Default');
    public static SMALL = new AString('Small');
    public static LARGE = new AString('Large');

    private static _types:Array<AString> = [
        Bulk.DEFAULT,
        Bulk.SMALL,
        Bulk.LARGE
    ];

    public static default():Bulk
    {
        return new Bulk(Bulk.DEFAULT);
    }

    public static large():Bulk
    {
        return new Bulk(Bulk.LARGE);
    }

    public static small():Bulk
    {
        return new Bulk(Bulk.SMALL);
    }

    public static isBulk(value:any):boolean
    {
        return value instanceof Bulk;
    }
}
